export const specialProductTypes: string[] = ['P0000002', 'P0000004', 'P0000023'];
